import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { LegacyButton } from '@/components/LegacyButton';
import { SectionHeader } from '@/components/SectionHeader';

export const Wrapper = styled(Box)`
  ${({ theme }) => css`
    display: none;

    ${theme.media.md.up} {
      display: block;
      text-align: left;
      margin: 0 auto;
      padding: ${theme.spacing(6, 0)};
      max-width: ${theme.breakpoints.lg};
    }
  `}
`;

export const Header = styled(SectionHeader)`
  text-align: center;
  margin-bottom: 0;

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.h1};
  `}
`;

export const ContinueShopping = styled(LegacyButton)<{ show: string }>`
  ${({ show }) => css`
    visibility: ${show === 'true' ? 'visible' : 'hidden'};
  `}
`;
